(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  $(document).on('click', '.shopify_explorer_faq__question', function(){
  $('.shopify_explorer_faq__question').not(this).next('.shopify_explorer_faq__answer').slideUp(250);
  $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
  $(this).toggleClass('active');
  });

  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-baby"]) return;
  try {
    
  document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    const parent = header.parentElement;
    const isOpen = content.classList.contains('open');
  
    // Close all sections
    document.querySelectorAll('.accordion-content').forEach(item => {
        item.classList.remove('open');
        item.style.maxHeight = '0';
        item.parentElement.classList.remove('active');
    });
  
    // Open clicked section if it wasn't already open
    if (!isOpen) {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        parent.classList.add('active');
    }
  });
  });
  
  // Set initial max-height for open section
  document.querySelector('.accordion-content.open').style.maxHeight = 
  document.querySelector('.accordion-content.open').scrollHeight + 'px';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    const parent = header.parentElement;
    const isOpen = content.classList.contains('open');
  
    // Close all sections
    document.querySelectorAll('.accordion-content').forEach(item => {
        item.classList.remove('open');
        item.style.maxHeight = '0';
        item.parentElement.classList.remove('active');
    });
  
    // Open clicked section if it wasn't already open
    if (!isOpen) {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        parent.classList.add('active');
    }
  });
  });
  
  // Set initial max-height for open section
  document.querySelector('.accordion-content.open').style.maxHeight = 
  document.querySelector('.accordion-content.open').scrollHeight + 'px';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  $(document).on('click', '.shopify_explorer_faq__question', function(){
  $('.shopify_explorer_faq__question').not(this).next('.shopify_explorer_faq__answer').slideUp(250);
  $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
  $(this).toggleClass('active');
  });

  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  $(document).on('click', '.product_faq__question', function(){
    if($(this).hasClass('active')){
      $(this).next().slideUp(250)
      $(this).removeClass('active');
    }
    else{
      $('.product_faq__question').removeClass('active');
      $(this).addClass('active');
      $('.product_faq__answer').hide();
      $(this).next().slideDown(250); 
    }
  });

  $(document).on('shopify:block:select', function(event) {
    $(event.target).find('.product_faq__answer').slideDown(550);
  });

  $(document).on('shopify:block:deselect', function(event) {
    $(event.target).find('.product_faq__answer').slideUp(550);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-and-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-item');
  
    faqItems.forEach(item => {
      item.addEventListener('click', function (e) {
        // Prevent double-toggle if answer area is clicked directly
        if (e.target.closest('.faq-answer')) return;
  
        const currentButton = item.querySelector('.faq-question');
        const currentAnswer = item.querySelector('.faq-answer');
  
        // Close all other FAQs
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.querySelector('.faq-question').classList.remove('open');
            const answer = otherItem.querySelector('.faq-answer');
            answer.classList.remove('active');
            answer.style.maxHeight = null;
          }
        });
  
        // Toggle current
        currentButton.classList.toggle('open');
        currentAnswer.classList.toggle('active');
  
        if (currentAnswer.classList.contains('active')) {
          currentAnswer.style.maxHeight = currentAnswer.scrollHeight + 'px';
        } else {
          currentAnswer.style.maxHeight = null;
        }
      });
    });
  });
  
  // Shopify Theme Editor support
  document.addEventListener('shopify:block:select', function (event) {
    const answer = event.target.querySelector('.faq-answer');
    const question = event.target.querySelector('.faq-question');
  
    if (answer && question) {
      answer.classList.add('active');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      question.classList.add('open');
    }
  });
  
  document.addEventListener('shopify:block:deselect', function (event) {
    const answer = event.target.querySelector('.faq-answer');
    const question = event.target.querySelector('.faq-question');
  
    if (answer && question) {
      answer.classList.remove('active');
      answer.style.maxHeight = null;
      question.classList.remove('open');
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["success-result"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll('.acne-results-section');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const circles = entry.target.querySelectorAll('.progress-circle .progress');

          circles.forEach(circle => {
            const radius = circle.r.baseVal.value;
            const circumference = 2 * Math.PI * radius;
            const percentage = parseFloat(getComputedStyle(circle).getPropertyValue('--percentage')) || 0;

            circle.style.strokeDasharray = `${circumference}`;
            circle.style.strokeDashoffset = circumference;

            setTimeout(() => {
              const offset = circumference - (percentage / 100) * circumference;
              circle.style.strokeDashoffset = offset;
            }, 100);
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.5
    });

    sections.forEach(section => observer.observe(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-faq"] && !Shopify.designMode) return;
  try {
    
  $(document).on('click', '.shopify_explorer_faq__question', function(){
  $('.shopify_explorer_faq__question').not(this).next('.shopify_explorer_faq__answer').slideUp(250);
  $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
  $(this).toggleClass('active');
  });

  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });

  } catch(e) { console.error(e); }
})();
})();
